import { i18n } from '@shared/i18n';
import { SubpropertyService } from '@modules/subproperty/subproperty-service';

import Errors from '@shared/error/errors';

const dashboardConfig = (isPropertyNBA) => ({
  players: {
    title: i18n('entities.player.amountOf'),
    emptyCaption: i18n('entities.player.empty'),
    iconClass: 'icon-player',
    borderColor: '#ee7266',
    iconColor: '#ffffff',
    iconBackgroundColor: 'rgba(38, 157, 226, .1)',
    tooltipCaption: i18n('entities.player.tooltipCaption')
  },
  programs: {
    title: isPropertyNBA ? i18n('entities.season.amountOf')  : i18n('entities.program.amountOf'),
    emptyCaption: isPropertyNBA ? i18n('entities.season.empty') :  i18n('entities.program.empty'),
    iconClass: 'icon-document',
    borderColor: '#2acccc',
    iconColor: '#2acccc',
    iconBackgroundColor: 'rgba(42, 204, 204, .27)',
    tooltipCaption: isPropertyNBA ? i18n('entities.season.tooltipCaption') : i18n('entities.program.tooltipCaption')
  },
  parents: {
    iconClass: 'icon-family',
    title: i18n('entities.parent.amountOf'),
    emptyCaption: i18n('entities.parent.empty'),
    borderColor: '#269de2',
    iconColor: '#ffffff',
    iconBackgroundColor: 'rgba(38, 157, 226, .1)',
    tooltipCaption: i18n('entities.parent.tooltipCaption')
  },
  teams: {
    iconClass: 'icon-teams',
    title: i18n('entities.team.amountOf'),
    emptyCaption: i18n('entities.team.empty'),
    borderColor: '#788bda',
    iconColor: '#ffffff',
    iconBackgroundColor: 'rgba(38, 157, 226, .1)',
    tooltipCaption: i18n('entities.team.tooltipCaption')
  },
  coaches: {
    iconClass: 'icon-cup',
    title: i18n('entities.coach.amountOf'),
    emptyCaption: i18n('entities.coach.empty'),
    borderColor: '#2acccc',
    iconColor: '#ffffff',
    iconBackgroundColor: 'rgba(38, 157, 226, .1)',
    tooltipCaption: i18n('entities.coach.tooltipCaption')
  },
  locations: {
    iconClass: 'icon-location',
    title: i18n('entities.location.amountOf'),
    emptyCaption: i18n('entities.location.empty'),
    borderColor: '#2acccc',
    iconColor: '#2acccc',
    iconBackgroundColor: 'rgba(42, 204, 204, .27)',
    tooltipCaption: i18n('entities.location.tooltipCaption')
  },
});

export default {
  namespaced: true,

  state: {
    loading: false,
    stats: [],
  },

  getters: {
    loading: state => state.loading,
    stats: state => state.stats,
    statsArray: state => Object.values(state.stats),
  },

  mutations: {
    FETCH_STARTED(state) {
      state.loading = true;
    },

    FETCH_SUCCESS(state, { stats }) {
      state.loading = false;
      state.stats = stats;
    },

    FETCH_ERROR(state) {
        state.loading = false;
        state.stats = [];
    },
  },

  actions: {
    async doFetch(
      { commit, rootGetters },
      { subpropertyId }
    ) {
      try {
        commit('FETCH_STARTED');

        const response = await SubpropertyService.dashboard(subpropertyId);
        const isPropertyNBA = rootGetters['auth/manage/isPropertyNBA'];
        const stats = Object.assign({}, dashboardConfig(isPropertyNBA));
        response.stats.forEach(({ type, amount }) => stats[type].count = amount);

        commit('FETCH_SUCCESS', { stats });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },
  },
};
